<template>
  <div>
    <div v-if="phase == 'waiting'">
      <p>Prosím o strpení, probíhá kontrola přihlášení</p>
    </div>
    <div v-if="phase == 'accepted'">
      <p>Ověřeno. Můžete pokračovat <a href="javascript:" v-on:click="continueHere()">zde</a>, nebo v předchozím okně.</p>
    </div>
    <div v-if="phase == 'error'">
      <p>Došlo k chybě během ověřování. Prosím opakujte postup, nebo kontakrujte přítele na telefonu...</p>
      <p>{{message}}</p>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import User from '../service/user';
import Cart from '../cart';
import Utils from '../utils';

import Notification from '../notification';


export default {
  name: 'Main',
  components: {
  },
  data () {
    return {
      phase: 'waiting',
      message: ''
    };
  },
  created() {
    if (this.$route.query.email && this.$route.query.token) {
      console.log('Verification for', this.$route.query.email, this.$route.query.token)

      axios.get('/cart/api/login/verify/' + this.$route.query.email + '/' + this.$route.query.token)
      .then(res => {
        console.log('Verification complete...', res)
        if (res.data.accepted) {
          this.phase = 'accepted'
          Utils.setCookie('id_token', res.data.token.id_token)
          Utils.setCookie('access_token', res.data.token.access_token)
          Utils.setCookie('cartId', res.data.token.cartId)
          Cart.data.cartId = res.data.token.cartId
          Cart.orderClosed = false
          User.context.authenticated = true
        } else {
          this.phase = 'error'
          this.message = res.message
        }
      })
      .catch(error => {
        this.phase = 'error'
        this.message = error.response.data.message
      });
    }
  },
  methods: {
    continueHere() {
      if (Cart.data.cartId) {
        Cart.loadCartContent(Cart.data.cartId)
      }
      this.$router.push({name: 'Order'})
    },
  }
}
</script>

<style scoped>

</style>
